const PUBLIC_AUTH_ROUTE_PREFIXES = [
  "/sign-in",
  "/ops/sign-in",
  "/sign-up",
  "/auth",
  "/reset-password",
  "/new-password",
  "/2fa"
] as const;

const SUPERTOKENS_DEFERRED_INIT_ROUTE_PREFIXES = ["/sign-in", "/ops/sign-in", "/sign-up", "/auth", "/2fa"] as const;
const PUBLIC_AUTH_API_PATH_PREFIXES = [
  "/be/v1/auth/signin",
  "/be/v1/auth/signup",
  "/be/v1/auth/signinup",
  "/be/v1/auth/authorisationurl",
  "/auth/signin",
  "/auth/signup",
  "/auth/signinup",
  "/auth/authorisationurl"
] as const;
const EMAIL_VERIFICATION_ROUTE_PREFIX = "/auth/verify-email";
const EMAIL_VERIFICATION_API_PATH_PREFIXES = ["/be/v1/auth/user/email/verify", "/auth/user/email/verify"] as const;

function stripPathDecorators(pathname: string): string {
  return pathname.split("?")[0].split("#")[0];
}

function normalizePathLike(input: string): string {
  try {
    const origin =
      typeof window !== "undefined" && window.location?.origin ? window.location.origin : "https://sellpath.invalid";
    return stripPathDecorators(new URL(input, origin).pathname);
  } catch {
    return stripPathDecorators(input);
  }
}

function matchesAnyPrefix(pathname: string, prefixes: readonly string[]): boolean {
  return prefixes.some((prefix) => {
    return pathname === prefix || pathname.startsWith(`${prefix}/`);
  });
}

export function isPublicAuthPath(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }

  return matchesAnyPrefix(normalizePathLike(pathname), PUBLIC_AUTH_ROUTE_PREFIXES);
}

export function shouldDeferSuperTokensInit(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }

  return matchesAnyPrefix(normalizePathLike(pathname), SUPERTOKENS_DEFERRED_INIT_ROUTE_PREFIXES);
}

export function isPublicAuthApiPath(pathnameOrUrl: string | null | undefined): boolean {
  if (!pathnameOrUrl) {
    return false;
  }

  return matchesAnyPrefix(normalizePathLike(pathnameOrUrl), PUBLIC_AUTH_API_PATH_PREFIXES);
}

export function isEmailVerificationPath(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }

  return matchesAnyPrefix(normalizePathLike(pathname), [EMAIL_VERIFICATION_ROUTE_PREFIX]);
}

export function isEmailVerificationApiPath(pathnameOrUrl: string | null | undefined): boolean {
  if (!pathnameOrUrl) {
    return false;
  }

  return matchesAnyPrefix(normalizePathLike(pathnameOrUrl), EMAIL_VERIFICATION_API_PATH_PREFIXES);
}

export function shouldBypassSessionInterception(
  requestUrl: string | null | undefined,
  currentPathname: string | null | undefined
): boolean {
  if (!requestUrl || !currentPathname) {
    return false;
  }

  return (
    isPublicAuthPath(currentPathname) && !isEmailVerificationPath(currentPathname) && isPublicAuthApiPath(requestUrl)
  );
}

export {
  EMAIL_VERIFICATION_API_PATH_PREFIXES,
  EMAIL_VERIFICATION_ROUTE_PREFIX,
  PUBLIC_AUTH_API_PATH_PREFIXES,
  PUBLIC_AUTH_ROUTE_PREFIXES,
  SUPERTOKENS_DEFERRED_INIT_ROUTE_PREFIXES
};
